/* ============================================================
   SBSL — Recharge Subscription Widget helpers
   Hide the in-widget one-time tier. CSS can't isolate it (no unique part, and
   :last-child on the forwarded part isn't honored), so reach into the open
   shadow roots and hide the option whose label is the one-time purchase.
   Order-independent and re-applied if the widget re-renders.
   One-time is offered via a separate link below the buy box.
   ============================================================ */
(function () {
  // The one-time row is labeled "One Bottle" on this store (not "One-time").
  // Match either wording so it stays hidden if the label changes.
  var ONE_TIME_RE = /one[\s-]*(bottle|time)/i;

  function applyHide(optionsRoot) {
    var options = optionsRoot.querySelectorAll('.rc-quantity-upsell-option');
    var found = false;
    options.forEach(function (opt) {
      if (ONE_TIME_RE.test(opt.textContent || '')) {
        opt.style.display = 'none';
        found = true;
      }
    });
    return found;
  }

  function init() {
    var host = document.querySelector('.single-pro recharge-subscription-widget');
    if (!host || !host.shadowRoot) return false;
    var inner = host.shadowRoot.querySelector('recharge-quantity-upsell');
    if (!inner || !inner.shadowRoot) return false;
    if (!applyHide(inner.shadowRoot)) return false;
    // Re-hide if Recharge re-renders the options (e.g. on variant change).
    new MutationObserver(function () { applyHide(inner.shadowRoot); })
      .observe(inner.shadowRoot, { childList: true, subtree: true });
    return true;
  }

  // The widget hydrates asynchronously — retry until the options exist (~10s).
  var tries = 0;
  var timer = setInterval(function () {
    if (init() || ++tries > 40) clearInterval(timer);
  }, 250);
})();

/* One-time purchase link — adds the current variant with NO selling plan (so
   it's a one-time buy). Recharge's /cart/add.js fetch interceptor opens the
   slide-out cart, same as the quick-add flow. */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.onetime-purchase-link');
    if (!link) return;
    e.preventDefault();

    // Prefer the product form's live variant id (updates on variant change),
    // fall back to the value rendered into the link.
    var variantId = link.getAttribute('data-variant-id');
    var idInput = document.querySelector('#buy-box [name="id"]');
    if (idInput && idInput.value) variantId = idInput.value;
    if (!variantId) return;

    link.setAttribute('aria-busy', 'true');
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);

    fetch('/cart/add.js', { method: 'POST', body: body })
      .then(function (r) { return r.json(); })
      .then(function () {
        // Keep the header count badge in sync (Recharge opens the drawer itself).
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.cart_qty_cls').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('hidden-count', cart.item_count === 0);
          });
        });
      })
      .catch(function (err) { console.error('One-time add error:', err); })
      .finally(function () { link.removeAttribute('aria-busy'); });
  });
})();

/* Subscribe ATC → auto-apply the first-order discount code. The Recharge drawer
   (app slide-out) renders off the /cart/add response and can't be refreshed
   theme-side, so the code must be in the session BEFORE the add. Apply it once,
   as soon as Subscribe is the selected plan (the default), so the cart already
   carries it when Recharge opens the drawer. One-time scoping is enforced on the
   discount in admin (a one-time line can't claim a subscription-scoped code). */
(function () {
  var card = document.getElementById('sbsl-onetime-price');
  var CODE = card && card.getAttribute('data-subscribe-discount-code');
  if (!CODE) return;                       // blank setting → disabled, graceful
  var applied = false;                     // idempotent per page load
  var tries = 0;
  var timer = setInterval(function () {
    var form = document.querySelector('.AddToCartForm_id');
    var sp = form && new FormData(form).get('selling_plan');
    if (sp) {                              // subscribe is the selected plan
      applied = true;
      clearInterval(timer);
      fetch('/discount/' + encodeURIComponent(CODE),
            { credentials: 'same-origin', redirect: 'follow' })
        .catch(function (err) { console.error('subscribe discount apply failed:', err); });
    } else if (++tries > 60) {             // ~15s cap (250ms * 60), like the widget retry
      clearInterval(timer);
    }
  }, 250);
})();

/* ============================================================
   STANDARD widget — append the per-order savings to the "Subscribe To Save"
   title (Recharge's title field has no price variable). Result:
   "Subscribe To Save $19.47 per order". Recomputes when the frequency changes.
   ============================================================ */
(function () {
  function deep(root, pred, out) {
    out = out || [];
    root.querySelectorAll('*').forEach(function (e) {
      if (pred(e)) out.push(e);
      if (e.shadowRoot) deep(e.shadowRoot, pred, out);
    });
    return out;
  }
  function partHas(e, s) { var p = e.getAttribute && e.getAttribute('part'); return p && p.indexOf(s) !== -1; }
  function priceOf(el) {
    if (!el) return NaN;
    var m = el.textContent.match(/[\d,]+\.\d{2}/);
    return m ? parseFloat(m[0].replace(/,/g, '')) : NaN;
  }
  // Per-day price line (Grüns-style), below the price. One order = ~1 month of
  // product, so divide the sale price by 30. Injected into the flex __prices wrapper
  // as a full-width row (order:3) so it sits under the price. Idempotent (observer-safe).
  var SBSL_SUPPLY_DAYS = 30;
  function injectPerDay(wrap, salePrice) {
    if (!wrap || !wrap.querySelector || !(salePrice > 0)) return;
    var txt = '$' + (salePrice / SBSL_SUPPLY_DAYS).toFixed(2) + '/day';
    var ex = wrap.querySelector('[data-sbsl-perday]');
    if (!ex) {
      var d = document.createElement('div');
      d.setAttribute('data-sbsl-perday', '');
      d.textContent = txt;
      d.style.cssText = 'order: 3; flex-basis: 100%; width: 100%; text-align: right; font-size: 12px; line-height: 1.2; color: var(--sbsl-muted, #929495); margin-top: -3px;';
      wrap.appendChild(d);
    } else if (ex.textContent !== txt) {
      ex.textContent = txt;
    }
  }
  // Subtitle under the option title (Grüns-style). The option `label` is a flex column
  // (title row, then the absolutely-positioned prices); the prices block now has 2 lines
  // (price + per-day), so the title needs a 2nd line too or the columns don't align.
  // Inject the subtitle right after the selector. Idempotent.
  var SBSL_SUB_SUBTITLE = 'Delivers Every 4 weeks';
  var SBSL_ONETIME_SUBTITLE = 'Delivered once';
  var SBSL_ONETIME_NEGATIVES = ['No Free Shipping', 'No Free Gifts'];
  function injectSubtitle(selectorEl, text) {
    if (!selectorEl) return;
    var label = selectorEl.parentElement;
    if (!label || !label.querySelector) return;
    var ex = label.querySelector('[data-sbsl-subtitle]');
    if (!ex) {
      var d = document.createElement('div');
      d.setAttribute('data-sbsl-subtitle', '');
      d.textContent = text;
      d.style.cssText = 'font-size: 13px; color: var(--sbsl-muted, #929495); line-height: 1.2; margin-top: 3px; margin-left: 28px;';
      if (selectorEl.nextSibling) label.insertBefore(d, selectorEl.nextSibling); else label.appendChild(d);
    } else if (ex.textContent !== text) {
      ex.textContent = text;
    }
  }
  // Grüns-style "you lose this" bullets under the one-time option. Hangs off the same
  // `label` flex column as injectSubtitle, BELOW the 'Delivered once' subtitle. Create-once
  // only (copy is static), so it never re-writes text and never loops the characterData
  // observer. Red ✕ marker only (#c0392b danger red — NOT brand coral #f36f40 = action).
  function injectOnetimeNegatives(selectorEl) {
    if (!selectorEl) return;
    var label = selectorEl.parentElement;
    if (!label || !label.querySelector) return;
    // Selected-state signal: primary = the one-time radio's .checked; fallback = the
    // wrapper's rc-selected attr (only when no radio is found). wrapper = selector → label → div.
    var wrap = selectorEl.parentElement && selectorEl.parentElement.parentElement;
    var radio = wrap && wrap.querySelector('input[value="onetime"]');
    var selected = radio ? !!radio.checked : !!(wrap && wrap.hasAttribute('rc-selected'));
    // Create-once, idempotent: if the ul already exists, only toggle visibility (style.display
    // is NOT observed by observeAll → no loop) and return.
    var ul = label.querySelector('[data-sbsl-onetime-neg]');
    if (ul) { ul.style.display = selected ? 'flex' : 'none'; return; }
    // Font-match the adjacent subtitle (harness Recharge rule): same line-height grid,
    // one step smaller than the 13px subtitle so the negatives read quieter.
    var subt = label.querySelector('[data-sbsl-subtitle]');
    var lh = '1.2';
    if (subt) { var cs = getComputedStyle(subt); if (cs && cs.lineHeight) lh = cs.lineHeight; }
    ul = document.createElement('ul');
    ul.setAttribute('data-sbsl-onetime-neg', '');
    ul.style.cssText = 'list-style:none; margin:4px 0 0; margin-left:28px; padding:0; ' +
      'display:none; flex-direction:row; flex-wrap:wrap; gap:4px 16px; font-size:12px; line-height:' + lh + ';';
    SBSL_ONETIME_NEGATIVES.forEach(function (txt) {
      var li = document.createElement('li');
      li.style.cssText = 'display:flex; align-items:flex-start; gap:6px; color:#383d3f;';
      var mark = document.createElement('span');
      mark.style.cssText = 'color:#c0392b; flex:0 0 auto; font-weight:700;';
      mark.textContent = '✕';   // ✕
      var t = document.createElement('span');
      t.textContent = txt;
      li.appendChild(mark);
      li.appendChild(t);
      ul.appendChild(li);
    });
    label.appendChild(ul);
    ul.style.display = selected ? 'flex' : 'none';
  }
  // Deliveries per year from the selected frequency (drives the annual-savings bullet).
  function deliveriesPerYear(host) {
    var s = deep(host.shadowRoot, function (e) { return e.tagName === 'SELECT'; })[0];
    var txt = s && s.selectedOptions && s.selectedOptions[0] ? s.selectedOptions[0].textContent : '';
    var m = txt.match(/(\d+)\s*(day|week|month)/i);
    if (!m) return 0;
    var n = parseInt(m[1], 10);
    if (!n) return 0;
    var unit = m[2].toLowerCase();
    if (unit === 'day') return 365 / n;
    if (unit === 'week') return 52 / n;
    return 12 / n;   // month
  }

  function apply(host) {
    var orig = deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__original-price'); })[0];
    var disc = deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__discounted-price'); })[0];
    var sel  = deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__selector_subscription'); })[0];
    if (!sel) return false;

    // OUR per-variant first-order price from the Liquid carrier — the source of
    // truth for the displayed subscribe price. foStr is the exact money string to
    // inject; fo is the number that drives the savings/banner math. Read here (not
    // later) so the price logic no longer depends on Recharge's disc/orig nodes.
    var card = document.getElementById('sbsl-onetime-price');
    var foStr = card && card.getAttribute('data-first-order');
    var fo = foStr ? parseFloat(foStr.replace(/[^0-9.]/g, '')) : NaN;
    // Our price is the source of truth; if the carrier is missing (no #sbsl-onetime-price
    // on the page), bail BEFORE any mutation and leave Recharge's native card intact —
    // never inject a "$NaN" price. On a real PDP the carrier is always rendered.
    if (isNaN(fo)) return false;
    var cmp = card && card.getAttribute('data-compare');
    var cmpNum = cmp ? parseFloat(cmp.replace(/[^0-9.]/g, '')) : NaN;

    // Hide Recharge's "Save 20%" badge — replaced by the MOST POPULAR banner below.
    // display:none is idempotent (Recharge re-renders the badge each apply() run).
    deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__badge'); })
      .forEach(function (b) { b.style.display = 'none'; });

    // Remove the plans dropdown (reachable only by class, not a part).
    deep(host.shadowRoot, function (e) { return e.classList && e.classList.contains('rc-plans-dropdown'); })
      .forEach(function (el) { el.style.display = 'none'; });

    // o = MSRP-ish anchor for the savings math; d = the DISPLAYED sale price = OUR
    // first-order value. Neither calls priceOf on a guaranteed node: o falls back
    // (orig → compare-at → fo) and d falls back (fo → disc → o), so the card renders
    // even when Recharge drops its __original-price/__discounted-price nodes (0% plan).
    var o = orig ? priceOf(orig) : (cmpNum || fo);
    var d = !isNaN(fo) ? fo : (disc ? priceOf(disc) : o);

    // MOST POPULAR banner — full-width strip injected as the FIRST child of the
    // subscribe card, bleeding to the card edges. % computed from MSRP vs the
    // displayed subscribe price (= 41% today). Only when there's a real MSRP above
    // the sale price; create-once marked node + guarded text write (observer-safe).
    var subCardEl = deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__subscription'); })[0];
    if (subCardEl && cmp && cmpNum > d) {
      var bannerPct = Math.round((cmpNum - d) / cmpNum * 100);
      var bannerText = 'MOST POPULAR · GET ' + bannerPct + '% OFF';
      var banner = subCardEl.querySelector('[data-sbsl-banner]');
      if (!banner) {
        banner = document.createElement('div');
        banner.setAttribute('data-sbsl-banner', '');
        banner.style.cssText = 'display:block; margin:-10px -18px 10px; border-radius:4px 4px 0 0; padding:6px 12px; background:#f7ece1; color:#44988e; border-bottom:1px solid #ecdccd; text-align:center; font-size:13px; font-weight:800; letter-spacing:.08em; text-transform:uppercase;';
        banner.textContent = bannerText;
        subCardEl.insertBefore(banner, subCardEl.firstChild);
      }
      if (banner.textContent !== bannerText) banner.textContent = bannerText;
    }

    // Price emphasis (Grüns-style): the sale price leads, large + bold; the struck
    // price follows, smaller + muted, baseline-aligned. Flex `order` reorders without
    // moving DOM (the wrapper is already flex); style-only writes don't trip the observer.
    // Derive the price wrapper defensively — at a 0% selling plan Recharge may drop
    // BOTH __original-price and __discounted-price, so fall back to the __prices /
    // __subscription container. We own the displayed price now, so it must resolve
    // without either price node.
    var subWrap = (orig && orig.parentNode)
      || (disc && disc.parentNode)
      || deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__prices'); })[0]
      || deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__subscription'); })[0];
    if (subWrap && subWrap.style) {
      subWrap.style.display = 'flex';
      subWrap.style.alignItems = 'baseline';
      subWrap.style.flexWrap = 'wrap';
      subWrap.style.justifyContent = 'flex-end';   // right-align the price line so it shares the per-day's right edge
      subWrap.style.columnGap = '6px';
    }
    // Hide Recharge's own price nodes — we render our own first-order price below.
    // Both hides are style-only + existence-guarded (idempotent, observer-safe).
    if (disc) disc.style.display = 'none';
    if (orig) orig.style.display = 'none';
    // Inject OUR first-order price (create-once + diffed text) — the visible price.
    if (subWrap) {
      var priceEx = subWrap.querySelector('[data-sbsl-sub-price]');
      if (!priceEx) {
        var ps = document.createElement('span');
        ps.setAttribute('data-sbsl-sub-price', '');
        ps.style.cssText = 'order: 1; font-size: 20px; line-height: 1.2; font-weight: 700;';
        ps.textContent = foStr || ('$' + d.toFixed(2));
        subWrap.appendChild(ps);
      } else if (foStr && priceEx.textContent !== foStr) {
        priceEx.textContent = foStr;
      }
    }
    if (cmp) {
      // Strike against the MSRP, not Recharge's list price ($59, where its 20% is
      // computed). Inject our own struck MSRP from the carrier (mirrors the one-time
      // approach). Recharge's own orig strike is already hidden above.
      var subEx = subWrap && subWrap.querySelector('[data-sbsl-sub-compare]');
      if (subWrap && !subEx) {
        var ss = document.createElement('s');
        ss.setAttribute('data-sbsl-sub-compare', '');
        ss.textContent = cmp;
        ss.style.cssText = 'order: 2; color: var(--sbsl-muted, #929495); text-decoration: line-through; font-weight: 400; font-size: 14px; line-height: 1.2; margin: 0;';
        subWrap.appendChild(ss);
      } else if (subEx && subEx.textContent !== cmp) {
        subEx.textContent = cmp;
      }
    }
    injectPerDay(subWrap, d);   // d = subscribe sale price
    injectSubtitle(sel, SBSL_SUB_SUBTITLE);   // balances the 2-line price block

    // The MOST POPULAR banner is a flow child of the card; it pushed the title down,
    // but the prices wrapper is position:absolute (anchored to the card) so it didn't
    // follow → title sat below the price. Nudge the prices down by the measured gap to
    // re-align. Measured once (flag-guarded → no oscillation); attribute writes aren't
    // observed → no loop. Re-measures if Recharge re-renders the wrapper (flag gone).
    var bnr = deep(host.shadowRoot, function (e) { return e.hasAttribute && e.hasAttribute('data-sbsl-banner'); })[0];
    var priceNode = subWrap && subWrap.querySelector('[data-sbsl-sub-price]');
    if (bnr && subWrap && sel && priceNode && !subWrap.hasAttribute('data-sbsl-aligned')) {
      // Anchor to OUR injected price node (the real visible price); disc is now hidden
      // (zeroed rect) or absent, so measuring it would mis-align or throw. priceNode in
      // the guard also makes the block a no-op when injection was skipped.
      var dy = Math.round(sel.getBoundingClientRect().top - priceNode.getBoundingClientRect().top);
      // transform (not margin) — margin is ignored on this top-anchored absolute wrapper.
      if (dy > 0) { subWrap.style.transform = 'translateY(' + dy + 'px)'; subWrap.setAttribute('data-sbsl-aligned', ''); }
    }

    // Overwrite Recharge's own title text node with our title. Recharge's label
    // field rejects "&", so we render "Subscribe & Save" here. (The savings
    // amount lives in the benefits bullet, not the heading.)
    var titleText = 'Subscribe & Save';
    var legacy = sel.querySelector('[data-sbsl-savings]');   // clean up the old span approach
    if (legacy) legacy.remove();
    var tNode = null;
    for (var ti = 0; ti < sel.childNodes.length; ti++) {
      var cn = sel.childNodes[ti];
      if (cn.nodeType === 3 && cn.nodeValue.trim()) { tNode = cn; break; }
    }
    if (tNode && tNode.nodeValue !== titleText) tNode.nodeValue = titleText;

    // Custom benefits — replace the app's stock checkmark list with our own bullets.
    var sub = deep(host.shadowRoot, function (e) { return partHas(e, 'rc-purchase-option__sub-container'); })[0];
    var tpl = document.getElementById('sbsl-sub-benefits');
    if (sub && tpl) {
      // Hide the app's benefits list.
      deep(host.shadowRoot, function (e) { return partHas(e, 'rc-benefits__list'); })
        .forEach(function (el) { el.style.display = 'none'; });
      // Inject our list (+ its scoped <style>) once into this sub-container.
      var mine = sub.querySelector('.subscription-widget-facade--selling-points');
      if (!mine) {
        var frag = tpl.content.cloneNode(true);
        mine = frag.querySelector('.subscription-widget-facade--selling-points');
        sub.insertBefore(frag, sub.firstChild);
      }
      // Discount % (from prices). Guard the write — re-setting textContent fires
      // the observer and would loop forever.
      var pct = mine.querySelector('[data-sbsl-discount]');
      if (pct) {
        // MSRP-based % when there's a compare-at (matches the banner = 41%);
        // fall back to the real list discount for non-MSRP products.
        var pctNum = (cmp && cmpNum > d)
          ? Math.round((cmpNum - d) / cmpNum * 100)
          : Math.round((o - d) / o * 100);
        var pctLi = pct.closest('li');
        if (pctNum > 0) {
          var pctText = pctNum + '%';
          if (pct.textContent !== pctText) pct.textContent = pctText;
          if (pctLi && pctLi.style.display === 'none') pctLi.style.display = '';
        } else if (pctLi && pctLi.style.display !== 'none') {
          // No discount (0%, no MSRP) → hide the bullet rather than show "0%".
          pctLi.style.display = 'none';
        }
      }
      // Annual savings = per-order saving x deliveries/year; hide the bullet if unknown.
      var ann = mine.querySelector('[data-sbsl-annual]');
      if (ann) {
        var py = deliveriesPerYear(host);
        var li = ann.closest('li');
        var save = o - d;
        if (py && save > 0) {
          var annText = '$' + (save * py).toFixed(2);
          if (ann.textContent !== annText) ann.textContent = annText;
          if (li && li.style.display === 'none') li.style.display = '';
        } else if (li && li.style.display !== 'none') {
          // No positive per-order saving (0% / no-MSRP, or unparseable) → hide rather than show $0.00/$NaN.
          li.style.display = 'none';
        }
      }
    }

    // One-time compare-at strikethrough — inject `~~$79.99~~ $59.00` before the
    // one-time price. Per-product from the Liquid carrier; skip entirely (return the
    // subscribe result, no injection) when there's no compare-at. Kept LAST so the
    // subscribe logic above always runs regardless of one-time state.
    if (cmp) {
      // The one-time __price is the one whose parent __prices wrapper has NO
      // __original-price descendant (the subscribe wrapper HAS one). Robust to order.
      // Match the EXACT part token (partHas is substring, which also matches the
      // plural `rc-purchase-option__prices` wrapper — we want only the price span).
      var partExactly = function (e, tok) {
        var p = e.getAttribute && e.getAttribute('part');
        return p && (' ' + p + ' ').indexOf(' ' + tok + ' ') !== -1;
      };
      var oneTime = deep(host.shadowRoot, function (e) { return partExactly(e, 'rc-purchase-option__price'); })
        .filter(function (priceSpan) {
          var w = priceSpan.parentNode;
          if (!w || !w.querySelectorAll) return false;
          return deep(w, function (x) { return partHas(x, 'rc-purchase-option__original-price'); }).length === 0;
        });
      // Exactly one one-time candidate must survive; if none, the widget isn't ready —
      // the observer/retry will re-run apply(). Bail without touching the subscribe wrapper.
      if (oneTime.length === 1 && oneTime[0].parentNode) {
        var priceSpan = oneTime[0];
        var wrap = priceSpan.parentNode;
        // Match the subscribe treatment: sale price leads large + bold, MSRP follows
        // smaller + muted + struck. Flex `order` controls layout, so the injected <s>
        // can stay before the price in the DOM. Baseline-align the differing sizes.
        if (wrap.style) {
          wrap.style.display = 'flex';
          wrap.style.alignItems = 'baseline';
          wrap.style.flexWrap = 'wrap';
          wrap.style.justifyContent = 'flex-end';   // right-align the price line to the per-day's right edge
          wrap.style.columnGap = '6px';
        }
        priceSpan.style.order = '1'; priceSpan.style.fontSize = '20px'; priceSpan.style.lineHeight = '1.2';
        var existing = wrap.querySelector('[data-sbsl-onetime-compare]');
        if (!existing) {
          var s = document.createElement('s');
          s.setAttribute('data-sbsl-onetime-compare', '');
          s.textContent = cmp;
          s.style.cssText = 'order: 2; color: var(--sbsl-muted, #929495); text-decoration: line-through; font-weight: 400; font-size: 14px; line-height: 1.2; margin: 0;';
          wrap.insertBefore(s, priceSpan);
        } else if (existing.textContent !== cmp) {
          existing.textContent = cmp;
        }
        injectPerDay(wrap, priceOf(priceSpan));   // one-time sale price
        var otSel = deep(host.shadowRoot, function (e) { return partExactly(e, 'rc-purchase-option__selector_onetime'); })[0];
        injectSubtitle(otSel, SBSL_ONETIME_SUBTITLE);
        // injectOnetimeNegatives(otSel);  // hidden per request — "No Free Shipping / No Free Gifts" off the one-time box
      }
    }
    return true;
  }

  function observeAll(root, cb) {
    new MutationObserver(cb).observe(root, { childList: true, subtree: true, characterData: true });
    root.querySelectorAll('*').forEach(function (e) { if (e.shadowRoot) observeAll(e.shadowRoot, cb); });
  }

  function init() {
    var host = document.querySelector('.single-pro recharge-subscription-widget');
    if (!host || !host.shadowRoot) return false;
    if (!apply(host)) return false;
    // Re-run when the widget re-renders (e.g. the "Deliver every" dropdown changes
    // the discount). Observe every shadow root so nested price updates are caught.
    observeAll(host.shadowRoot, function () { apply(host); });
    return true;
  }

  var tries = 0;
  var timer = setInterval(function () { if (init() || ++tries > 40) clearInterval(timer); }, 250);
})();

/* ============================================================
   QUANTITY UPSELL widget — custom skin (ADDITIVE; spec buybox-quantity-upsell).
   Runs ONLY when the Recharge Quantity Upsell model is active (a
   <recharge-quantity-upsell> exists in the DOM). For each SUBSCRIBE tier it
   re-skins to match the Standard subscribe card — MOST POPULAR banner on the
   selected tier, a Save% pill on the others, our struck price + $X/day, and our
   bullet list — hides the in-widget "One Bottle" row (one-time stays the
   hyperlink below the box), and auto-applies the matching coupon on tier select
   (2-bottle -> BUY2 / 3-bottle -> BUY3, codes from theme settings).
   Everything above (Standard widget, SURPRISE wiring, the facade) is untouched;
   helpers are duplicated here on purpose. Under the Standard model no QU tiers
   exist, so this no-ops -> flipping Recharge back to Standard leaves zero trace. */
(function () {
  function deep(root, pred, out) {
    out = out || [];
    root.querySelectorAll('*').forEach(function (e) {
      if (pred(e)) out.push(e);
      if (e.shadowRoot) deep(e.shadowRoot, pred, out);
    });
    return out;
  }
  function partHas(e, tok) {
    var p = e.getAttribute && e.getAttribute('part');
    return !!p && (' ' + p + ' ').indexOf(' ' + tok + ' ') !== -1;
  }
  function hasClass(e, s) { return typeof e.className === 'string' && e.className.indexOf(s) !== -1; }
  function priceOf(el) {
    var m = el && (el.textContent || '').match(/[\d,]+\.\d{2}/);
    return m ? parseFloat(m[0].replace(/,/g, '')) : NaN;
  }
  function symOf(s) { var m = (s || '').match(/^[^\d]*/); return (m && m[0].trim()) || '$'; }
  function money(sym, n) { return sym + n.toFixed(2); }
  function num(s) { var m = (s || '').match(/[\d,]+\.\d{2}|[\d,]+/); return m ? parseFloat(m[0].replace(/,/g, '')) : NaN; }

  var carrier = document.getElementById('sbsl-onetime-price');
  function attr(n) { return (carrier && carrier.getAttribute(n)) || ''; }

  var SUPPLY_DAYS = 30;
  var BANNER_BG = '#f7ece1', BANNER_FG = '#44988e', BANNER_BD = '#ecdccd';
  var SAVE_ACTIVE = '#44988e';     // selected tier — teal highlight
  var SAVE_INACTIVE = '#929495';   // unselected tier — neutral grey

  // Tier match by title text. qty drives $/day (qty months ≈ qty*30 days);
  // pct/code come from the theme-setting carrier. recommend = the banner tier.
  // Tier config keyed by BOTTLE COUNT (qty). Title/subtitle/label are OUR consistent labels
  // (we override the Recharge plan name); code/pct come from the carrier settings.
  function tierForQty(qty) {
    if (qty <= 1) return { qty: 1, oneTime: true };
    if (qty === 2) return { qty: 2, pct: parseFloat(attr('data-qu-2-pct')), code: attr('data-qu-2-code'), sub: '2 Products Every 8 Weeks', label: 'GREAT VALUE', title: '2-Month Supply' };
    if (qty === 3) return { qty: 3, pct: parseFloat(attr('data-qu-3-pct')), code: attr('data-qu-3-code'), recommend: true, sub: '3 Products Every 12 Weeks', label: 'MOST POPULAR', title: '3-Month Supply' };
    return null;
  }
  // Raw (pre-takeover) tier price from the price node — used to derive the bottle count.
  function rawPrice(opt) {
    var pn = priceNode(opt);
    if (!pn) return NaN;
    return pn.hasAttribute('data-sbslqu-orig') ? parseFloat(pn.getAttribute('data-sbslqu-orig')) : priceOf(pn);
  }
  // Identify a tier by BOTTLE COUNT (tier price / single-bottle price = data-price) so it works
  // on any product regardless of plan naming. Falls back to the plan-name regex.
  function classify(opt) {
    var perBottle = num(attr('data-price'));
    var price = rawPrice(opt);
    if (perBottle > 0 && !isNaN(price)) {
      var t = tierForQty(Math.round(price / perBottle));
      if (t) return t;
    }
    var tEl = titleNode(opt);
    var txt = (tEl ? tEl.textContent : '') || opt.textContent || '';
    if (/3[\s-]*month|3\s*bottle|3\s*jar/i.test(txt)) return tierForQty(3);
    if (/2[\s-]*month|2\s*bottle|2\s*jar/i.test(txt)) return tierForQty(2);
    if (/one[\s-]*bottle|one[\s-]*time|1[\s-]*month|1\s*bottle|1\s*jar/i.test(txt)) return tierForQty(1);
    return null;
  }
  // Replace the Recharge plan name with our consistent label. The Recharge title is a
  // lit-html bound node — overwriting its text fights lit's re-render and DUPLICATES it.
  // So we HIDE the lit title and inject our own title element (lit doesn't manage it).
  // Returns our title element (the layout anchor for the subtitle).
  function overrideTitle(tEl, title) {
    if (!tEl || !title) return null;
    var tc = tEl.parentElement;
    if (!tc) return null;
    tEl.style.display = 'none';
    var mine = tc.querySelector('[data-sbslqu-title]');
    if (!mine) {
      mine = document.createElement('div');
      mine.setAttribute('data-sbslqu-title', '');
      mine.style.cssText = 'display:block; white-space:nowrap; font-weight:700;';
      tc.insertBefore(mine, tEl.nextSibling);
    }
    if (mine.textContent !== title) mine.textContent = title;
    return mine;
  }

  function titleNode(opt) {
    // EXACT class — hasClass() is substring and would match __title-container (a flex
    // column) instead of the title text, stretching anything we append into it.
    return deep(opt, function (e) { return e.classList && e.classList.contains('rc-quantity-upsell-option__title'); })[0] || null;
  }
  function priceNode(opt) {
    var taken = opt.querySelector('[data-sbslqu-price]');
    if (taken) return taken;
    return deep(opt, function (e) {
      // NEVER pick one of our own injected money nodes (sale/cmp) — that would recompute
      // a shrinking price every pass and feed the observer loop. Skip our subtree.
      if (e.closest && e.closest('[data-sbslqu-price]')) return false;
      return e.children.length === 0 && /[\d,]+\.\d{2}/.test(e.textContent || '') && !hasClass(e, 'rc-quantity-upsell-option__title');
    })[0] || null;
  }

  function ensureBanner(opt, tier, savePct, show) {
    if (show && !tier.label) show = false;
    var b = opt.querySelector('[data-sbslqu-banner]');
    if (!b && show) {
      b = document.createElement('div');
      b.setAttribute('data-sbslqu-banner', '');
      b.style.cssText = 'margin:-16px -18px 12px; border-radius:4px 4px 0 0; padding:6px 12px; background:' + BANNER_BG + '; color:' + BANNER_FG + '; border-bottom:1px solid ' + BANNER_BD + '; text-align:center; font-size:13px; font-weight:800; letter-spacing:.06em; text-transform:uppercase;';
      opt.insertBefore(b, opt.firstChild);
    }
    if (b) {
      var text = (tier.label || '') + (savePct > 0 ? ' · ' + Math.round(savePct) + '% OFF' : '');
      if (show && b.textContent !== text) b.textContent = text;
      b.style.display = show ? 'block' : 'none';
    }
  }

  // Save pill — INLINE right after the title text, shown on BOTH tiers at all times.
  // Selected tier = teal highlight; unselected = neutral grey. Deduped against re-renders.
  function ensureSavePill(opt, savePct, tEl, isSel) {
    if (!tEl) return;
    // On BOTH tiers — the banner is now just a label, not the %, so the pill carries the
    // number everywhere. Teal when selected, neutral grey when not.
    var show = savePct > 0;
    var pills = deep(opt, function (e) { return e.hasAttribute && e.hasAttribute('data-sbslqu-save'); });
    for (var i = 1; i < pills.length; i++) { if (pills[i].parentNode) pills[i].parentNode.removeChild(pills[i]); }
    var s = pills[0];
    if (!s && show) {
      s = document.createElement('span');
      s.setAttribute('data-sbslqu-save', '');
      tEl.appendChild(s);   // inline, inside the title (after the tier name)
    }
    if (s) {
      var bg = isSel ? SAVE_ACTIVE : SAVE_INACTIVE;
      s.style.cssText = 'display:inline-block; margin-left:8px; padding:2px 8px; border-radius:11px; background:' + bg + '; color:#fff; font-size:11px; font-weight:700; line-height:1.4; letter-spacing:.02em; white-space:nowrap; vertical-align:middle;';
      var text = 'Save ' + Math.round(savePct) + '%';
      if (show && s.textContent !== text) s.textContent = text;
      s.style.display = show ? 'inline-block' : 'none';
    }
  }

  // Take over the tier's price node: render OUR sale (P minus tier%) large + bold,
  // strike the original P, add $X/day. P (the Recharge tier price) is the source of
  // truth and reconciles to checkout (the coupon is exactly tier% off that line).
  function injectPrice(opt, tier) {
    var pn = priceNode(opt);
    if (!pn || isNaN(tier.pct)) return null;
    var P, sym;
    if (pn.hasAttribute('data-sbslqu-price')) {
      P = parseFloat(pn.getAttribute('data-sbslqu-orig'));
      sym = pn.getAttribute('data-sbslqu-sym') || '$';
    } else {
      P = priceOf(pn);
      if (isNaN(P)) return null;
      sym = symOf(pn.textContent);
      pn.setAttribute('data-sbslqu-price', '');
      pn.setAttribute('data-sbslqu-orig', String(P));
      pn.setAttribute('data-sbslqu-sym', sym);
      pn.style.cssText = 'display:flex; flex-direction:column; align-items:flex-end; line-height:1.2;';
      pn.textContent = '';
      // Row 1: sale + struck side-by-side (baseline aligned). Row 2: per-day underneath.
      var row = document.createElement('div');
      row.style.cssText = 'display:flex; flex-direction:row; align-items:baseline; justify-content:flex-end; gap:6px;';
      var saleEl = document.createElement('span');
      saleEl.setAttribute('data-sbslqu-sale', '');
      saleEl.style.cssText = 'font-size:20px; font-weight:700; color:#383d3f; line-height:1.2;';
      var cmpEl = document.createElement('s');
      cmpEl.setAttribute('data-sbslqu-cmp', '');
      cmpEl.style.cssText = 'font-size:14px; font-weight:400; color:var(--sbsl-muted,#929495); text-decoration:line-through; line-height:1.2;';
      var eaEl = document.createElement('span');
      eaEl.textContent = '/ea';
      eaEl.style.cssText = 'font-size:12px; font-weight:400; color:var(--sbsl-muted,#929495); line-height:1.2; margin-left:-3px;';
      row.appendChild(saleEl); row.appendChild(eaEl); row.appendChild(cmpEl);
      var dayEl = document.createElement('span');
      dayEl.setAttribute('data-sbslqu-day', '');
      dayEl.style.cssText = 'font-size:12px; font-weight:400; color:var(--sbsl-muted,#929495); line-height:1.3; margin-top:1px;';
      pn.appendChild(row); pn.appendChild(dayEl);
    }
    // PER-BOTTLE pricing so the value ladder reads right (3-pack cheapest per bottle).
    // sale = line-per-bottle × (1 - coupon%) = the real per-bottle checkout price.
    var perBottle = P / tier.qty;                          // line price per bottle (e.g. $35)
    var sale = perBottle * (1 - tier.pct / 100);           // after the coupon, per bottle
    var perMSRP = num(attr('data-compare'));                // per-bottle MSRP (compare-at)
    var strikeVal = (perMSRP > sale) ? perMSRP : perBottle; // strike the per-bottle MSRP
    var savePct = strikeVal > sale ? Math.round((strikeVal - sale) / strikeVal * 100) : 0;
    var set = function (sel, v) { var el = pn.querySelector(sel); if (el && el.textContent !== v) el.textContent = v; };
    set('[data-sbslqu-sale]', money(sym, sale));
    set('[data-sbslqu-cmp]', money(sym, strikeVal));
    set('[data-sbslqu-day]', money(sym, sale / SUPPLY_DAYS) + '/day');
    return { savePct: savePct, total: sale * tier.qty, sym: sym };
  }

  // Show our bullets (+ rewards) on the SELECTED tier; hide them when it's deselected so
  // the card collapses back to a compact row. Inserts bullets BEFORE Recharge's learn-more
  // (never moves it) so the learn-more can't multiply across switches.
  function injectBenefits(opt, show) {
    var cc = deep(opt, function (e) { return hasClass(e, 'rc-quantity-upsell-option__content-container'); })[0] || opt;
    var mine = cc.querySelector('.subscription-widget-facade--selling-points');
    if (show && !mine) {
      var tpl = document.getElementById('sbsl-sub-benefits');
      if (tpl) {
        var frag = tpl.content.cloneNode(true);
        var lm0 = deep(opt, function (e) { return e.tagName === 'RC-LEARN-MORE'; })[0];
        if (lm0 && lm0.parentNode) lm0.parentNode.insertBefore(frag, lm0); else cc.appendChild(frag);
        mine = cc.querySelector('.subscription-widget-facade--selling-points');
      }
    }
    var rewards = cc.querySelector('.sbsl-rewards');
    if (mine) mine.style.display = show ? '' : 'none';
    if (rewards) rewards.style.display = show ? '' : 'none';
    // Pull the bullets / rewards / learn-more back to the radio's left edge (full width),
    // while the title + subtitle stay indented next to the radio. Matches the reference.
    var SHIFT = '-32px';
    if (mine) { mine.style.marginLeft = SHIFT; mine.style.fontWeight = '400'; mine.querySelectorAll('li, .subscription-widget-facade--text').forEach(function (e) { e.style.fontWeight = '400'; }); }
    if (rewards) rewards.style.marginLeft = SHIFT;
    var summary = cc.querySelector('.sbsl-rewards > summary');
    if (summary) summary.style.fontWeight = '500';
    // Hide Recharge's native bullet list while ours is shown.
    deep(opt, function (e) { return e.tagName === 'RC-BENEFITS' || partHas(e, 'rc-benefits__list'); })
      .forEach(function (el) { el.style.display = (show && mine) ? 'none' : ''; });
    // Exactly one learn-more visible on the selected tier; hide the rest / all when collapsed.
    var lms = deep(opt, function (e) { return e.tagName === 'RC-LEARN-MORE'; });
    lms.forEach(function (el, i) { el.style.display = (show && i === 0) ? '' : 'none'; if (i === 0) el.style.marginLeft = SHIFT; });
  }

  // Hide the theme's quantity controls under QU — the selected tier already sets the
  // quantity, so a separate stepper is redundant/confusing. Light DOM; QU-only (this
  // module never runs under the Standard model), so the Standard layout keeps its stepper.
  // QU-only: mute the "Discount Auto-Applied" tag to grey so it doesn't compete with the
  // teal one-time link. The shared Liquid element stays teal under the Standard model.
  function muteAutoDiscount() {
    document.querySelectorAll('.sbsl-autodiscount').forEach(function (el) { el.style.color = '#929495'; });
  }

  function hideThemeQtyUI() {
    // Hide the stepper wrapper AND the bare quantity input (it sits directly under the
    // form, not always inside .product-form__qty) AND the standalone quantity_selector
    // block. display:none keeps the input in the form, so the tier's quantity still posts.
    ['#buy-box .product-form__qty', '#buy-box quantity-input', '#buy-box .quantity__input', '.single-pro .product-form__quantity'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.style.display = 'none'; });
    });
  }

  function hideBadges(opt) {
    deep(opt, function (e) { return partHas(e, 'rc-purchase-option__badge') || partHas(e, 'rc-quantity-upsell-badge__recommended'); })
      .forEach(function (b) { b.style.display = 'none'; });
  }

  // Subtitle under the title (selected/expanded tier only) — matches the Standard card's
  // "Delivers Every 4 weeks" line for pixel parity.
  // Make the title-container a proper LEFT COLUMN: title (nowrap, bold) with the subtitle
  // and Save pill stacked under it; price stays the right column, both top-aligned. Without
  // this the title wraps ("3-Month / Supply") and the subtitle drops below the price block.
  function styleCardLayout(tEl) {
    if (!tEl) return;
    var tc = tEl.parentElement;            // .rc-quantity-upsell-option__title-container
    var header = tc && tc.parentElement;   // .rc-quantity-upsell-option__header
    if (header && header.style) header.style.alignItems = 'flex-start';
    if (tc && tc.style) {
      tc.style.display = 'flex'; tc.style.flexDirection = 'column';
      tc.style.alignItems = 'flex-start'; tc.style.flex = '1 1 auto'; tc.style.minWidth = '0';
    }
  }

  function injectSubtitle(opt, tEl, text, show) {
    if (!tEl || !text) return;
    var ex = opt.querySelector('[data-sbslqu-subtitle]');
    if (!ex && show) {
      var d = document.createElement('div');
      d.setAttribute('data-sbslqu-subtitle', '');
      d.textContent = text;
      d.style.cssText = 'font-size:13px; color:var(--sbsl-muted,#929495); line-height:1.3; margin:1px 0 0; font-weight:400; white-space:nowrap;';
      tEl.insertAdjacentElement('afterend', d);   // directly under the title, in the title column
      ex = d;
    }
    if (ex) { if (show && ex.textContent !== text) ex.textContent = text; ex.style.display = show ? 'block' : 'none'; }
  }

  // Quiet value cue on the UNSELECTED tier ("39% OFF") — its banner isn't shown, so this
  // keeps the savings visible. Sits under the title (the subtitle slot is free when unselected).
  function ensureSavingsCue(opt, anchor, savePct, show) {
    if (!anchor) return;
    show = show && savePct > 0;
    var ex = opt.querySelector('[data-sbslqu-savecue]');
    if (!ex && show) {
      ex = document.createElement('div');
      ex.setAttribute('data-sbslqu-savecue', '');
      ex.style.cssText = 'font-size:13px; color:' + SAVE_INACTIVE + '; line-height:1.2; margin:2px 0 0; font-weight:600; letter-spacing:.02em;';
      anchor.insertAdjacentElement('afterend', ex);
    }
    if (ex) { var t = Math.round(savePct) + '% OFF'; if (show && ex.textContent !== t) ex.textContent = t; ex.style.display = show ? 'block' : 'none'; }
  }

  // One-time purchase link below the buy box — Recharge renders it in the Standard widget
  // but NOT under QU, so we inject it. The existing .onetime-purchase-link handler adds 1
  // bottle (qty 1, no selling plan) straight to cart. Shows the one-time price + struck MSRP.
  function ensureOnetimeLink(qu) {
    // Anchor to the ACTUAL rendered widget's host (qu's shadow-root host), not a
    // querySelector that can grab a duplicate widget higher in the mobile DOM.
    var host = (qu && qu.getRootNode && qu.getRootNode().host) || document.querySelector('.single-pro recharge-subscription-widget');
    if (!host) return;
    var price = attr('data-price');
    if (!price) return;
    var cmp = attr('data-compare');
    var vinput = document.querySelector('#buy-box [name="id"]');
    var vid = vinput ? vinput.value : '';
    var a = document.getElementById('sbsl-qu-onetime');
    if (!a) {
      a = document.createElement('a');
      a.id = 'sbsl-qu-onetime';
      a.className = 'onetime-purchase-link';
      a.href = '#';
      a.style.cssText = 'display:block; text-align:center; margin:16px 0 2px; color:#44988e; text-decoration:none; font-size:15px; cursor:pointer;';
      // Anchor to the widget host (the visible tiers) — directly below them, above ATC.
      // Avoids landing at a duplicate #buy-box higher in the mobile DOM.
      if (host.parentNode) host.parentNode.insertBefore(a, host.nextSibling);
    }
    if (a.getAttribute('data-variant-id') !== vid) a.setAttribute('data-variant-id', vid);
    // Underline the link text + price together; MSRP struck inside grey brackets.
    var html = '<span style="text-decoration:underline; text-underline-offset:2px; font-weight:600;">One-time purchase ' + price + '</span>'
             + (cmp ? ' <span style="color:#929495; font-weight:400; font-size:13px;">(<s>' + cmp + '</s>)</span>' : '');
    if (a.innerHTML !== html) a.innerHTML = html;
  }

  var lastCode = null;
  function applyCoupon(code) {
    if (!code || code === lastCode) return;
    lastCode = code;
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'follow' })
      .catch(function (err) { console.error('QU discount apply failed:', err); });
  }

  function apply(qu) {
    // Tier cards live in the QU element's shadow root — deep(qu) would only scan its
    // (empty) light DOM and find nothing. Scope to the shadow root.
    var root = qu.shadowRoot || qu;
    var cards = deep(root, function (e) { return partHas(e, 'rc-quantity-upsell-option'); });
    if (!cards.length) return false;
    var selectedTier = null;
    cards.forEach(function (opt) {
      var tier = classify(opt);
      if (!tier) return;
      if (tier.oneTime) { opt.style.display = 'none'; return; }
      var tEl = titleNode(opt);
      var sel = partHas(opt, 'rc-quantity-upsell-option__selected');
      var pr = injectPrice(opt, tier);
      var savePct = pr ? pr.savePct : 0;
      styleCardLayout(tEl);
      var myTitle = overrideTitle(tEl, tier.title);
      injectSubtitle(opt, myTitle || tEl, tier.sub, sel);
      ensureSavingsCue(opt, myTitle || tEl, savePct, !sel);
      ensureBanner(opt, tier, savePct, sel);
      injectBenefits(opt, sel);
      if (sel) { hideBadges(opt); selectedTier = tier; }
    });
    hideThemeQtyUI();
    ensureOnetimeLink(qu);
    muteAutoDiscount();
    if (selectedTier && selectedTier.code) applyCoupon(selectedTier.code);
    return true;
  }

  function observeAll(root, cb) {
    new MutationObserver(cb).observe(root, { childList: true, subtree: true, characterData: true });
    root.querySelectorAll('*').forEach(function (e) { if (e.shadowRoot) observeAll(e.shadowRoot, cb); });
  }

  function findQU() { return deep(document, function (e) { return e.tagName === 'RECHARGE-QUANTITY-UPSELL'; })[0] || null; }

  // Re-entrancy guard: apply() mutates the shadow DOM, which fires our own observer. Without
  // this, the observer re-runs apply() on apply()'s own writes → infinite loop / page freeze
  // (notably on tier switch-back). While applying is true the observer is a no-op; we release
  // on the next macrotask, AFTER the microtask-queued observer callbacks for our own mutations
  // have run and been ignored. Genuine later changes (Recharge re-render, user click) re-fire.
  var applying = false;
  function guardedApply(qu) {
    if (applying) return;
    applying = true;
    try { apply(qu); } finally { setTimeout(function () { applying = false; }, 0); }
  }

  function init() {
    var qu = findQU();
    if (!qu || !qu.shadowRoot) return false;
    applying = true;
    var ok = apply(qu);
    setTimeout(function () { applying = false; }, 0);
    if (!ok) return false;
    // childList/characterData catches re-renders; a composed click catches tier
    // selection (a `part` attribute swap we don't observe) — re-apply after Recharge updates.
    observeAll(qu.shadowRoot, function () { guardedApply(qu); });
    qu.addEventListener('click', function () {
      setTimeout(function () { guardedApply(qu); }, 60);
      setTimeout(function () { guardedApply(qu); }, 300);
    });
    // Re-assert the selected tier's coupon after the Standard SURPRISE one-shot may have
    // fired (a cart holds one code; last /discount/ write wins). Guarantees BUY2/BUY3 win
    // over SURPRISE under QU regardless of load order. Harmless under no-SURPRISE configs.
    [1500, 3500].forEach(function (t) { setTimeout(function () { lastCode = null; guardedApply(qu); }, t); });
    return true;
  }

  var tries = 0;
  var timer = setInterval(function () { if (init() || ++tries > 60) clearInterval(timer); }, 250);
})();
